import type { KeycloakLike } from "./AuthProvider";

export async function initKeycloak(): Promise<KeycloakLike> {
  const { default: Keycloak } = await import("keycloak-js");
  // || not ??: the Docker build passes these ARGs as EMPTY STRINGS when
  // unset, and "" ?? default keeps "" -> broken login redirect to
  // /realms//... (live finding 2026-07-02, first operator-console rebuild
  // in weeks).
  const keycloak = new Keycloak({
    url: import.meta.env.VITE_KC_URL || "https://auth.strawa.net",
    realm: import.meta.env.VITE_KC_REALM || "strawa-platform",
    clientId: import.meta.env.VITE_KC_CLIENT_ID || "strawatar-console",
  }) as unknown as KeycloakLike;
  await keycloak.init({
    onLoad: "login-required",
    pkceMethod: "S256",
    checkLoginIframe: false,
  });
  return keycloak;
}
